import { useCallback, useEffect, useState } from 'react';
import { supabase } from './supabase';

/** Count of rows treated as unread in the inbox (status unread or null). */
export function useInboxUnreadCount() {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    const { count: c, error } = await supabase
      .from('user_messages')
      .select('id', { count: 'exact', head: true })
      .or('status.eq.unread,status.is.null');
    if (!error) setCount(c ?? 0);
  }, []);

  useEffect(() => {
    void refresh();
    const channel = supabase
      .channel('admin-inbox-unread')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'user_messages' }, () => {
        void refresh();
      })
      .subscribe();
    return () => {
      void supabase.removeChannel(channel);
    };
  }, [refresh]);

  return { count, refresh };
}
